import Bootstrap from './Bootstrap';

export { configureApp } from './configureApp';

export default Bootstrap;
